<template>
    <div class="report-fs">


        <md-card-content dir="rtl" class="redirect-dir">
            <div class="md-layout">
                <div class="md-layout-item">
                    <md-card>

                        <md-card-header style=" margin-bottom: 30px;" class="md-card-header-text md-card-header-green">
                            <div class="card-text">
                                <h4 class="title">تقرير الكفاءة السنوية</h4>
                            </div>
                        </md-card-header>


                        <div style="margin-top: 10px; margin-bottom: 35px; " class="marginTop">
                            <md-card-content>


                                <md-table class="paginated-table table-striped table-hover mt-25">
                                    <md-table-row>


                                        <md-table-cell>ر.م</md-table-cell>

                                        <md-table-cell class="w-200">اسم الموظف</md-table-cell>


                                        <md-table-cell class="w-100">السنة</md-table-cell>

                                        <md-table-cell class="w-200">التقييم</md-table-cell>



                                    </md-table-row>
                                    <md-table-row v-for="(item, i) in data" :key="i">

                                        <md-table-cell md-label="الصنف">{{
                                        i + 1
                                    }}</md-table-cell>

                                        <md-table-cell class="w-200" md-label="الصنف">{{
                                            item.employeeName
                                        }}</md-table-cell>


                                        <md-table-cell class="w-100" md-label="الصنف">{{
                                            item.year
                                        }}</md-table-cell>

                                        <md-table-cell class="w-200" md-label="الصنف">{{
                                            item.efficiencyString
                                        }}</md-table-cell>


                                    </md-table-row>
                                </md-table>

                            </md-card-content>
                        </div>

                    </md-card>
                </div>

            </div>
        </md-card-content>

    </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
    mounted() { },
    props: ["allData", "data"],
    data() {
        return {
            currentSort: "",
            currentSortOrder: "asc",
            m: env.mTop(),

        };
    },
    methods: {
        convert(event) {
            try {
                let d = new Date(event);
                if (event == null) {
                    return "";
                }

                return (
                    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
        convertToUi(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return " - ";
                }
                return (
                    d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === "desc") {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
    },
};
</script>
